

<script>
/* eslint-disable */
import zrMixin from "./mixins/zrmixin";
export default {
  name: "RobotMarker",
  mixins: [zrMixin],
  props: {
    position: {
      type: Array,
      default() {
        return [0, 0];
      },
    },
  },
  data() {
    return {
      events: ["click"],
    };
  },
  methods: {
    init() {
      let position = this.position;

      position = this.$parent.robotPositionToMapPosition(position);
      // console.log(position);
      // console.log(this.$parent.mapPositionToRobotPosition(position));

      let x = position[0] || 0;
      let y = position[1] || 0;

      var circle = new zrender.Circle({
        shape: {
          cx: x,
          cy: y,
          r: 4,
        },
        style: {
          fill: "#409EFF",
        },
      });
      this.$zrComponent = circle;
      // console.log(circle);

      this.$zr.add(circle);
    },
    //注册事件
    registerEvent() {
      if (this.$zrComponent) {
        this.events.map((eventKey) => {
          this.$zrComponent.on(eventKey, (e) => {
            // console.log(e);
            // if (e.target) {
            //   let shape = e.target.shape;
            //   let position = [shape.cx, shape.cy];
            //   console.log(this.$parent.mapPositionToRobotPosition(position));
            // }
            this.$emit(eventKey, e);
          });
        });
      }
    },
    //更新位置
    updatePosition() {
      if (this.$zrComponent) {
        let position = this.position;

        position = this.$parent.robotPositionToMapPosition(position);

        let x = position[0] || 0;
        let y = position[1] || 0;
        this.$zrComponent.attr({
          shape: {
            cx: x,
            cy: y,
          },
        });
      }
    },
  },
  render() {
    return null;
  },

  watch: {
    position: {
      handler: function () {
        this.updatePosition();
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>